// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.accounts', {
        url: '/accounts?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/accounts/accounts.tpl.html',
            controller: 'AccountsController as vm'
        }},
        resolve: {
            accounts: accountsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function accountsResolver(AccountsApiService, $stateParams) {
    return AccountsApiService.getAccounts({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function AccountsController($rootScope, $state, $scope, accounts, AccountsApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.accounts = accounts;
    vm.selectedAccountId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.accountId; }, function(newValue, oldValue) {
            vm.selectedAccountId = parseInt($state.params.accountId,10);
        });
        $rootScope.$on('Account.Inserted', function(event, response) {
        });
        $rootScope.$on('Account.Updated', function(event, response) {
        });
        $rootScope.$on('Account.Deleted', function(event, response) {
        });
        $rootScope.$on('Account.Changed', function(event, response) {
            loadAccounts();
        });
    }

    function loadAccounts() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        AccountsApiService.getAccounts(request).then(function(response) {
            vm.accounts = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadAccounts();
    }

}

angular
    .module('base.accounts', ['accounts.api','accounts.account'])
    .config(stateConfig)
    .controller('AccountsController', AccountsController);
